<div class="event-search-box">
  <form class="event-search-form" (ngSubmit)="goSearch()">
    <div class="search-holder" matAutocompleteOrigin #searchBoxOrigin="matAutocompleteOrigin">
      <span class="material-icons-outlined mat-icon">
        search </span>
      <input class="search-control" type="text" [formControl]="searchControl" [matAutocomplete]="searchAutoComplete"
        [matAutocompleteConnectedTo]="searchBoxOrigin" #searchKey
        [placeholder]="'shared.labels.searchPlaceHolder' | translate" autocomplete="off" />
    </div>

    <mat-autocomplete class="suggestion-list" #searchAutoComplete="matAutocomplete"
      (optionSelected)="onOptionSelected($event.option.value)">
      <ng-container *ngIf="hasSuggestions">
        <mat-optgroup *ngIf="nameSuggestions.length > 0" label="Etkinlikler">
          <mat-option *ngFor="let item of nameSuggestions" [value]="item.label" class="suggestion-option">
            <span class="suggestion-label">{{ item.label }}</span>
            <span class="suggestion-count">{{ 'shared.labels.searchSuggestionEvent' | translate: { p1: item.count }
              }}</span>
          </mat-option>
        </mat-optgroup>

        <mat-optgroup *ngIf="groupSuggestions.length > 0" label="Etkinlik Grupları">
          <mat-option *ngFor="let item of groupSuggestions" [value]="item.label" class="suggestion-option">
            <span class="suggestion-label">{{ item.label }}</span>
            <span class="suggestion-count">{{ 'shared.labels.searchSuggestionEventGroup' | translate: { p1: item.count }
              }}</span>
          </mat-option>
        </mat-optgroup>

        <mat-optgroup *ngIf="venueSuggestions.length > 0" label="Mekanlar">
          <mat-option *ngFor="let item of venueSuggestions" [value]="item.label" class="suggestion-option">
            <span class="suggestion-label">{{ item.label }}</span>
            <span class="suggestion-count">{{ 'shared.labels.searchSuggestionVenue' | translate: { p1: item.count }
              }}</span>
          </mat-option>
        </mat-optgroup>
      </ng-container>

      <ng-container *ngIf="!hasSuggestions && spellcheckSuggestions.length > 0">
        <mat-optgroup label="Bunu mu demek istediniz?">
          <mat-option *ngFor="let word of spellcheckSuggestions" [value]="word" class="suggestion-option spellcheck-option">
            <span class="suggestion-label">{{ word }}</span>
          </mat-option>
        </mat-optgroup>
      </ng-container>

    </mat-autocomplete>
  </form>
</div>
